import {  types } from '../../actions'

function getOilConditions(seasons){
       
	const seasonOil = {}

	seasons.map(function(season) {
		const { id,oilChallengeFrom,oilChallengeTo,oilStandardFrom,oilStandardTo,oilSportTo, isSeasonSet } = season
		const oil = {
			seasonId: id,
			challengeFrom: oilChallengeFrom ? oilChallengeFrom.toFixed(2): null,
			challengeTo:oilChallengeTo ? oilChallengeTo.toFixed(2): null,
			standardFrom:oilStandardFrom ? oilStandardFrom.toFixed(2): null,
			standardTo:oilStandardTo ? oilStandardTo.toFixed(2) : null,
			sportTo:oilSportTo ? oilSportTo.toFixed(2): null,
			isSeasonSet
		}
		seasonOil[id] = oil
	})
	return seasonOil
}
       
export default function seasonoil (state={},action) {   
	const {  payload } = action      

	switch(action.type) {
		case (types.Season.FETCH_ACTIVE_SEASONS): {           
			const { data } = payload
			if (data) {                
				const defaultId = payload.data[0].id
				const oilConditions = getOilConditions(data)

				return Object.assign({},state, {
					values: {
						conditions:oilConditions,
						settingsseason:defaultId,
						initialstate:oilConditions,
						oilreset:false,
					},
					fields: {
						conditions:oilConditions,
						settingsseason:defaultId,
						initialstate:oilConditions,
						oilreset:false,
					}
				})
			}
			else {
				return state
			}
		}
		case types.Season.SAVING_SEASON_OIL: {
			const response = {
				savingoil: true,
			}
			return  { ...state, 
				values: {
					...state.values ,
					...response        
				},
				fields: {
					...state.fields,
					...response 
				}
			}
		}
		case types.Season.SAVE_SEASON_OILCONDITIONS: {
			const datasaved  = true 
			const savingoil = false
			return  { ...state, 
				values: {
					...state.values,
					savingoil,
					datasaved,
					initialstate:state.values.conditions,
					oilreset: false         
				},
				fields: {
					...state.fields,
					savingoil,
					datasaved,
					initialstate:state.fields.conditions,
					oilreset: false
				}
			}
		}
		case types.Season.TRIGGER_SEASON: {
			const { data } = payload;
			if (data) {
				const defaultId = data[data.length - 1].id
				const oilConditions = getOilConditions(data)
				const response = {
					conditions: oilConditions,
					settingsseason: defaultId,
					oilreset: false
				};

				return  { 
					...state, 
					values:
					{
						...state.values ,
						...response        
					},
					fields: 
					{
						...state.fields,
						...response 
					}
				}
			}
			break;
		}
		case types.RESET_OIL_SETTINGS:{
             
			const { initialstate } = state.values
  
			const response = {
				conditions:initialstate,
				oilreset:true
			}
		
			return  { ...state, 
				values: {
						...state.values,
						...response
				},
				fields: {
						...state.fields,
						...response
				}
			}
		}
		default: return state;
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonoil.js